import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=e0c653e0"
import script from "./UploadedFiles.vue?vue&type=script&lang=ts"
export * from "./UploadedFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports